// extracted by mini-css-extract-plugin
export var modalFooter = "_q0-0";